// extracted by mini-css-extract-plugin
export default {"wrapper":"TeamViewerSupport_wrapper__wemNk","itemWrapper":"TeamViewerSupport_itemWrapper__j1WpA","item":"TeamViewerSupport_item__pzEI-","mobile":"TeamViewerSupport_mobile__FRSlz"};